import { render, staticRenderFns } from "./AdminAffiliatePromotionEditPage.vue?vue&type=template&id=fb309940&scoped=true"
import script from "./AdminAffiliatePromotionEditPage.vue?vue&type=script&lang=js"
export * from "./AdminAffiliatePromotionEditPage.vue?vue&type=script&lang=js"
import style0 from "./AdminAffiliatePromotionEditPage.vue?vue&type=style&index=0&id=fb309940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb309940",
  null
  
)

export default component.exports